"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var _clsx2 = _interopRequireDefault(require("clsx"));
var _LocaleProvider = require("../LocaleProvider");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function getCount(value, maxLength) {
  return "".concat("".concat(value).length).concat(maxLength ? "/".concat(maxLength) : '');
}
var PREFIX = (0, _getPrefixCls.getPrefixCls)('input');
var Input = function Input(props) {
  var _useLocale = (0, _LocaleProvider.useLocale)(),
    trans = _useLocale.trans;
  var _props$placeholder = props.placeholder,
    placeholder = _props$placeholder === void 0 ? trans('input_placeholder') : _props$placeholder,
    _props$value = props.value,
    value = _props$value === void 0 ? '' : _props$value,
    multiline = props.multiline,
    autoSize = props.autoSize,
    maxLength = props.maxLength,
    showCount = props.showCount,
    _props$onChange = props.onChange,
    onChange = _props$onChange === void 0 ? function () {} : _props$onChange,
    className = props.className,
    _props$onSubmit = props.onSubmit,
    onSubmit = _props$onSubmit === void 0 ? function () {} : _props$onSubmit,
    disabled = props.disabled,
    rows = props.rows;
  var isMultiline = multiline || autoSize;
  var Element = isMultiline ? 'textarea' : 'input';
  var onKeyPress = function onKeyPress(e) {
    if (e.key === 'Enter') {
      onSubmit(value);
    }
  };
  var handleChange = (0, _react.useCallback)(function (e) {
    if (onChange) {
      var valueFromEvent = e.target.value;
      var shouldTrim = maxLength && valueFromEvent.length > maxLength;
      var val = shouldTrim ? valueFromEvent.substr(0, maxLength) : valueFromEvent;
      onChange(val, e);
    }
  }, [maxLength, onChange]);
  var input = /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx2.default)(PREFIX, className)
  }, /*#__PURE__*/_react.default.createElement(Element, {
    className: (0, _clsx2.default)("".concat(PREFIX, "__").concat(Element), (0, _defineProperty2.default)({}, "".concat(PREFIX, "__").concat(Element, "--bordered"), isMultiline)),
    placeholder: placeholder,
    rows: rows,
    value: value,
    maxLength: maxLength,
    onChange: handleChange,
    disabled: disabled,
    onKeyPress: onKeyPress
  }));
  if (showCount) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx2.default)("".concat(PREFIX, "-wrapper"))
    }, input, showCount && /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(PREFIX, "-counter")
    }, getCount(value, maxLength)));
  }
  return input;
};
exports.Input = Input;
Input.displayName = 'Input';